import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext.js';
import EulaModal from '../components/EulaModal.js';
import TwoFactorAuth from '../components/TwoFactorAuth.js';
import api from '../api.js';
import '../styles/App.css';

const Login = () => {
  const { login } = useAuth();
  
  // State management
  const [show2FA, setShow2FA] = useState(false);
  const [showEula, setShowEula] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Login form state
  const [loginData, setLoginData] = useState({
    email: '',
    password: '',
    eula: false
  });


  // Handle login form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // First check if the API is reachable
      try {
        await api.healthCheck();
      } catch (healthError) {
        console.warn('Health check failed, but continuing with login attempt:', healthError);
      }

      const result = await login(loginData.email, loginData.password, loginData.eula);
      
      // If login returns user data, it means 2FA was skipped (trusted device)
      if (result.user) {
        setSuccess('Login successful! Redirecting...');
        // Auth context will handle redirect automatically
      } else {
        // Show 2FA as before
        setShow2FA(true);
        setSuccess('Please check your email for the 2FA code');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Handle 2FA success
  const handle2FASuccess = () => {
    // The auth context will handle the redirect automatically
    // when isLoggedIn becomes true
  };

  // Handle 2FA back
  const handle2FABack = () => {
    setShow2FA(false);
    setError('');
    setSuccess('');
  };

  // Handle input changes
  const handleLoginChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Show 2FA component if login was successful
  if (show2FA) {
    return (
      <TwoFactorAuth 
        onSuccess={handle2FASuccess}
        onBack={handle2FABack}
      />
    );
  }

  return (
    <>
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1 style={{ color: '#fff' }}>OSIRIS</h1>
            <p>by Skill & Reach</p>
          </div>

          {/* Remove tab container and registration tab */}

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          {/* Only show login form */}
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                name="email"
                value={loginData.email}
                onChange={handleLoginChange}
                placeholder="Enter your email"
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                name="password"
                value={loginData.password}
                onChange={handleLoginChange}
                placeholder="Enter your password"
                required
                className="form-input"
              />
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="eula"
                  checked={loginData.eula}
                  onChange={handleLoginChange}
                  required
                />
                <span>
                  I accept the{' '}
                  <span 
                    className="eula-link" 
                    onClick={() => setShowEula(true)}
                  >
                    EULA
                  </span>
                </span>
              </label>
            </div>


            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ background: 'var(--primary-color)', color: 'var(--secondary-color)', fontWeight: 700 }}
              disabled={loading || !loginData.eula}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>

      <EulaModal isOpen={showEula} onClose={() => setShowEula(false)} />
    </>
  );
};

export default Login;
